//判断是否安装客户端程序
export function clientIf(type, url, chat, token, loginName) {
  url = `${url}?token=${token}&loginName=${loginName}`
  function hasFastMsgInstalled() {
    var xmlhttp = null
    var bComplete,
      bInstalled = false
    try {
      xmlhttp = new XMLHttpRequest()
    } catch (e) {
      var versions = [
        'MSXML2.XMLHTTP.6.0',
        'MSXML2.XMLHTTP.5.0',
        'MSXML2.XMLHTTP.4.0',
        'MSXML2.XMLHTTP.3.0',
        'MSXML2.XMLHTTP.2.6',
        'MSXML2.XMLHTTP',
        'Microsoft.XMLHTTP'
      ]
      for (var i = 0; i < versions.length; i++) {
        try {
          xmlhttp = new ActiveXObject(versions[i])
        } catch (e) {
          xmlhttp = null
        }
        if (xmlhttp) break
      } //for
    } //catch
    if (!xmlhttp) return false
    if (typeof xmlhttp == 'undefined') return false
    xmlhttp.onreadystatechange = function() {
      if (xmlhttp.readyState == 4 && !bComplete) {
        bComplete = true
        if (xmlhttp.responseText == 'OK') {
          bInstalled = true
        }
      }
    }

    xmlhttp.open('GET', 'http://127.0.0.1:33333?rand=' + Math.random(), false)
    try {
      xmlhttp.send(null)
    } catch (e) {}
    return bInstalled
  }
  var ret = hasFastMsgInstalled()
  window.location.href =
    'xiaopmsg2://go?pwd=123456&user=' + type + '&url=' + url + '&chat=' + chat //用来启动本地客户端
  console.log(
    'xiaopmsg2://go?pwd=123456&user=' + type + '&url=' + url + '&chat=' + chat
  )

  // if (ret) {
  //   window.location.href = "xiaopmsg://go?pwd=123456&user="+type+'&url='+url+'&chat='+chat; //用来启动本地客户端
  //   //window.open("fastmsg://go?user=admin&pwd=123456&chat=user2&video=true");
  // } else {
  //   //直接跳转下载页面
  //   window.location.href = `https://msgapache.g-part.cn/download/`;
  // }
}
